import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/lib/auth";
import PermissionsPanel from "@/components/PermissionsPanel";
import AppHeader from "@/components/AppHeader";
import MasterList from "@/components/admin/MasterList";
import FinishesTable from "@/components/admin/FinishesTable";
import TierSettings from "@/components/admin/TierSettings";
import BrandingSettings from "@/components/admin/BrandingSettings";
import QuotationSettings from "@/components/admin/QuotationSettings";

export default function Admin() {
  const { role } = useAuth();
  const isAdmin = role === "admin";

  return (
    <>
    <AppHeader />
    <div className="min-h-screen pt-24 pb-40 max-w-2xl mx-auto px-4">
      <div className="flex items-center justify-between mb-6">
        <Link to="/dashboard" className="inline-flex items-center gap-1.5 text-white/50 hover:text-white text-sm" data-testid="admin-to-home">
          <ArrowLeft size={14} /> Dashboard
        </Link>
      </div>

      <div className="mb-6">
        <div className="overline text-[#C5A880] mb-2">Settings</div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold">Workspace setup</h1>
        <p className="text-white/50 mt-2 text-sm">
          Manage finishes, accessories, pricing tiers, branding and payment plans for this workspace.
        </p>
      </div>

      <Tabs defaultValue="finishes">
        <TabsList className="bg-[#161922] border border-white/5 mb-4 flex-wrap h-auto">
          <TabsTrigger value="finishes" data-testid="tab-finishes">
            Finishes
          </TabsTrigger>
          <TabsTrigger value="accessories" data-testid="tab-accessories">
            Accessories
          </TabsTrigger>
          <TabsTrigger value="tiers" data-testid="tab-tiers">
            Tiers
          </TabsTrigger>
          <TabsTrigger value="branding" data-testid="tab-branding">
            Branding
          </TabsTrigger>
          <TabsTrigger value="quotation" data-testid="tab-quotation">
            Quotation
          </TabsTrigger>
          {isAdmin && (
            <TabsTrigger value="access" data-testid="tab-access">
              Access
            </TabsTrigger>
          )}
        </TabsList>

        <TabsContent value="finishes">
          <FinishesTable />
        </TabsContent>
        <TabsContent value="accessories">
          <MasterList
            kind="accessory"
            endpoint="/accessories"
            importExportKey="accessories"
            priceKey="price_per_unit"
            priceLabel="Price / unit (₹)"
            title="Accessory"
          />
        </TabsContent>
        <TabsContent value="tiers">
          <TierSettings />
        </TabsContent>
        <TabsContent value="branding">
          <BrandingSettings />
        </TabsContent>
        <TabsContent value="quotation">
          <QuotationSettings />
        </TabsContent>
        {isAdmin && (
          <TabsContent value="access">
            <PermissionsPanel />
          </TabsContent>
        )}
      </Tabs>
    </div>
    </>
  );
}
